module.exports = __webpack_public_path__ + "static/portfolio-4-2670f65d4457443bc6a4fb7be85ac2d1.jpg";